import React, { ReactNode } from 'react';
import { StyledSystemProps } from '../../types';
import { Box } from '../../wag-react/next-components/box';
import { theme } from '../../wag-react/themes/base-theme';
type Props = StyledSystemProps & {
  children: ReactNode;
};

// Note: Unlike other related components. ArticleAdviceCard for iPad and above uses desktop layout
// and not mobile layout. Design said it's fine to use desktop layout on iPad screen
export const ArticleAdviceCard = ({
  children,
  ...rest
}: Props) => <Box border={['1px solid']} borderColor={theme.colors.whisper} borderRadius={['12px']} overflow="hidden" {...rest} data-sentry-element="Box" data-sentry-component="ArticleAdviceCard" data-sentry-source-file="index.tsx">
    {children}
  </Box>;
export type ArticleAdviceCardProps = Props;